import { produce } from "immer";
import {
  FETCH_VOTES,
  FETCH_VOTES_FAILURE,
  FETCH_VOTES_SUCCESS,
} from "./constants";

export const initialState = {
  isFetchingVotes: false,
  votes: [],
};

const FeedVotesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // List
      case FETCH_VOTES:
        draft.isFetchingVotes = true;
        draft.votes = [];
        break;
      case FETCH_VOTES_SUCCESS:
        draft.isFetchingVotes = false;
        draft.votes = action.payload;
        break;
      case FETCH_VOTES_FAILURE:
        draft.isFetchingVotes = false;
        draft.votes = [];
        break;
      default:
        return state;
    }
  });

export default FeedVotesReducer;
